/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
/**
 * Builds a multipart FormData for the branding upload endpoint, including only
 * the files the admin actually picked and the remove flags they toggled.
 */
export function buildBrandingFormData(form) {
  const fd = new FormData();
  if (form.brandLogoFile) fd.append('brand_logo', form.brandLogoFile);
  if (form.brandLogoDarkFile)
    fd.append('brand_logo_dark', form.brandLogoDarkFile);
  if (form.brandFaviconFile) fd.append('brand_favicon', form.brandFaviconFile);
  if (form.removeBrandLogo) fd.append('remove_brand_logo', 'true');
  if (form.removeBrandLogoDark) fd.append('remove_brand_logo_dark', 'true');
  if (form.removeBrandFavicon) fd.append('remove_brand_favicon', 'true');
  return fd;
}
